// extracted by extract-css-chunks-webpack-plugin
module.exports = {"main":"main_drXRJ","ui_mask":"ui_mask_6IaJp"};